import { createAction } from 'redux-actions';
import * as types from '@src/store/types';

export const getThemesClientCall = createAction(types.GET_THEMES_CLIENT_CALL);
export const getThemesClientDone = createAction(types.GET_THEMES_CLIENT_DONE);
export const getThemesClientFail = createAction(types.GET_THEMES_CLIENT_FAIL);
